import { defineComponent as _defineComponent } from 'vue'
import { Offer } from '@/@types/graphql-types';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { computed, ref } from 'vue';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import FreeTrialSwiperOSContainer from '@/features/buybox/components/grid/FreeTrialSwiperOSContainer.vue';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { observableOptions } from '@/helpers/composables/useOfferImpressionTracking';

interface PromotionSwiperItem {
	id?: string | number;
	[key: string]: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionSwiper',
  props: {
    items: null,
    title: null,
    offers: null,
    additionalContexts: { default: () => [] },
    slideDelay: { default: 1500 },
    initialSlide: { default: 0 },
    isPromoted: { type: Boolean, default: false },
    trackingProperty: { default: 'promotion_swiper' },
    autoSwipe: { type: Boolean, default: false },
    autoSwipeDelay: { default: 1500 },
    hideControls: { type: Boolean, default: false },
    isNativeSQTVActive: { type: Boolean, default: false }
  },
  emits: ["slideChange"],
  setup(__props: any, { emit }: { emit: ({
	(
		e: 'slideChange',
		payload: {
			direction: string;
			position: number;
			nonInteraction: boolean;
		}
	): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { items: PromotionSwiperItem[], title: TitleDetail, offers: Offer[], additionalContexts: SnowplowContext[], slideDelay: number, initialSlide: number, isPromoted: boolean, trackingProperty: string, autoSwipe: boolean, autoSwipeDelay: number, hideControls: boolean, isNativeSQTVActive: boolean };





const swipeIndex = ref(0);

const isShowOrSeason = computed(() => ['Show', 'Season'].includes(props.title.__typename));

// Auto-swipe configuration: when enabled, swipe to second slide (index 1) after component is 50% visible
const effectiveInitialSlide = computed(() => {
	if (props.autoSwipe && props.items.length > 1) {
		return 1; // Auto-swipe to second slide
	}
	return props.initialSlide;
});

const effectiveSlideDelay = computed(() => {
	const delay = props.autoSwipe ? props.autoSwipeDelay : props.slideDelay;
	return delay - observableOptions.throttle;
});

// Enable viewport-based auto-swipe when autoSwipe is true
const enableViewportAutoSwipe = computed(() => props.autoSwipe && props.items.length > 1);
/* Native SQTV Ad */
const persistedAutoSwipeDelay = computed(() => (props.isNativeSQTVActive ? 7000 : undefined));

/* Native SQTV Ad */
function getItemKey(item: PromotionSwiperItem, index: number): string | number {
	return item.id ?? index;
}

function handleSlideChange({
	direction,
	position,
	nonInteraction,
}: {
	direction: string;
	position: number;
	nonInteraction: boolean;
}) {
	const parsedInitialPosition = Number(swipeIndex.value);
	const initialPosition = isNaN(parsedInitialPosition) ? undefined : parsedInitialPosition;

	const category = nonInteraction ? 'automation' : 'userinteraction';
	const action = nonInteraction ? 'auto_swipe' : 'swipe_clicked';

	swipeIndex.value = position;

	TrackingHelper.trackEvent(category, {
		action,
		label: direction,
		nonInteraction,
		value: initialPosition,
		property: props.trackingProperty,
	});

	emit('slideChange', {
		direction,
		position,
		nonInteraction,
	});
}

return { __sfc: true,props, emit, swipeIndex, isShowOrSeason, effectiveInitialSlide, effectiveSlideDelay, enableViewportAutoSwipe, persistedAutoSwipeDelay, getItemKey, handleSlideChange, FreeTrialSwiperOSContainer }
}

})